exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close[data-v-90718474] {\n  outline: none;\n}", ""]);

// exports
